export interface Testimonial {
  name: string;
  avatarUrl: string;
  quote: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Gastón",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/08b04c55-7ebc-433a-ba62-2a61ffc60a4d.jpg",
    quote:
      "“Súper práctico. Me ahorra muchísimo tiempo y me permite explicarle mejor a mis alumnos cómo hacer cada ejercicio, incluso cuando trabajamos a distancia. Se ve mucho más profesional.”",
  },
  {
    name: "Alejandro",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/365ea681-5afd-454e-b7a7-f2b867afa5ea.jpg",
    quote:
      "“La biblioteca está muy bien organizada y eso hace todo más rápido. Cuando un alumno me pregunta por un ejercicio, se lo puedo enviar en segundos por WhatsApp y queda mucho más claro. Para trabajo online me sirve muchísimo.”",
  },
  {
    name: "Anabella",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/4b481a82-3022-4967-bacc-191236c1ad57.jpg",
    quote:
      "“Me encantó porque me ayuda a acompañar al alumno de una forma mucho más profesional, aunque no esté presencialmente con él. Es práctico, rápido y le da mucho más valor a mi servicio.”",
  },
];
